/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OtherDocsDocuments from './OtherDocsDocuments';

/**
 * The OtherDocs model module.
 * @module model/OtherDocs
 * @version 1.0.0
 */
class OtherDocs {
    /**
     * Constructs a new <code>OtherDocs</code>.
     * @alias module:model/OtherDocs
     */
    constructor() { 
        
        OtherDocs.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OtherDocs</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OtherDocs} obj Optional instance to populate.
     * @return {module:model/OtherDocs} The populated <code>OtherDocs</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OtherDocs();

            if (data.hasOwnProperty('validated')) {
                obj['validated'] = ApiClient.convertToType(data['validated'], 'Boolean');
            }
            if (data.hasOwnProperty('documents')) {
                obj['documents'] = OtherDocsDocuments.constructFromObject(data['documents']);
            }
        }
        return obj;
    }


}

/**
 * @member {Boolean} validated
 */
OtherDocs.prototype['validated'] = undefined;

/**
 * @member {module:model/OtherDocsDocuments} documents
 */
OtherDocs.prototype['documents'] = undefined;






export default OtherDocs;

